"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeNodeIdToAnswerPathMap = makeNodeIdToAnswerPathMap;
exports.isAnswerPathCollectionTreeNode = isAnswerPathCollectionTreeNode;
exports.isAnswerPathLeafNode = isAnswerPathLeafNode;
const AnswerPath_1 = require("./AnswerPath");
function makeNodeIdToAnswerPathMap(nodePaths) {
    const nodeIdToAnswerPaths = new Map();
    for (const pathTreeNode of nodePaths) {
        addMappingForSubTree(pathTreeNode, nodeIdToAnswerPaths);
    }
    return new Map(nodeIdToAnswerPaths);
}
function addMappingForSubTree(pathTreeNode, knownNodeIdToAnswerPaths, parent) {
    const { path, nodeId } = pathTreeNode;
    const isCollection = isAnswerPathCollectionTreeNode(pathTreeNode);
    const answerPath = new AnswerPath_1.AnswerPath({ path, parent, isCollection, nodeId });
    if (pathTreeNode.nodeId) {
        if (knownNodeIdToAnswerPaths.has(pathTreeNode.nodeId)) {
            throw Error(`${pathTreeNode.nodeId} already exists in NodeIdToAnswerPathMap`);
        }
        knownNodeIdToAnswerPaths.set(pathTreeNode.nodeId, answerPath);
    }
    if (!isAnswerPathLeafNode(pathTreeNode)) {
        for (const child of pathTreeNode.children) {
            addMappingForSubTree(child, knownNodeIdToAnswerPaths, answerPath);
        }
    }
}
function isAnswerPathCollectionTreeNode(treeNode) {
    return treeNode.isCollection;
}
function isAnswerPathLeafNode(treeNode) {
    return !!treeNode.nodeId && typeof treeNode.children === 'undefined';
}
